import Vue from 'vue'
import VueReceiveCoupon from './receive-coupon'

let instance

const ReceiveCoupon = (coupon, type) => {
  if (!instance) {
    instance = new (Vue.extend(VueReceiveCoupon))({
      el: document.createElement('div')
    })
    document.body.appendChild(instance.$el)
  }
  instance.clickCoupon(coupon, type)
}

ReceiveCoupon.install = Vue => {
  Vue.prototype.$receiveCoupon = ReceiveCoupon
}

export default ReceiveCoupon
